import type { ReactNode } from "react";
import useInView from "../hooks/useInView";

export default function Reveal({
  children,
  className = "",
  threshold = 0.2,
}: {
  children: ReactNode;
  className?: string;
  threshold?: number;
}) {
  const { ref, inView } = useInView<HTMLDivElement>(threshold);

  return (
    <div ref={ref} className={`${inView ? "animate-reveal-in" : "opacity-0"} ${className}`}>
      {children}
    </div>
  );
}
